export const IS_FETCHING_STRIPE = "IS_FETCHING_STRIPE";
export const SET_STRIPE_ERROR_MESSAGE = "SET_STRIPE_ERROR_MESSAGE";
export const SET_STRIPE_COUPON = "SET_STRIPE_COUPON";
export const SET_STRIPE_INCORRECT_COUPON = "SET_STRIPE_INCORRECT_COUPON";
